import { siteInfo } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden pt-16 md:pt-20"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinematic%20background%20with%20warm%20red%20and%20amber%20gradient%20lighting%20abstract%20geometric%20shapes%20soft%20glow%20effects%20mysterious%20atmosphere%20editorial%20style%20no%20text%20high%20contrast%20deep%20shadows&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="黑料每日大赛 Hero 背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-sm font-medium text-accent-300 whitespace-nowrap">今日已更新 50+ 条爆料</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight text-balance">
              黑料每日大赛
              <span className="block text-accent-400 mt-1">全网吃瓜第一站</span>
            </h1>

            <p className="text-base md:text-lg text-white/80 leading-relaxed mt-4 max-w-xl lg:max-w-none">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-6">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/10">
                    <i className={`${stat.icon} text-accent-400 text-sm`}></i>
                  </span>
                  <div className="text-left">
                    <div className="text-lg md:text-xl font-bold text-white">{stat.value}</div>
                    <div className="text-xs text-white/60">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-xl transition-all duration-200 text-base whitespace-nowrap cursor-pointer text-center"
              >
                立即吃瓜
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-medium rounded-xl transition-all duration-200 text-base whitespace-nowrap cursor-pointer text-center backdrop-blur-sm border border-white/20"
              >
                查看排行榜
                <i className="ri-bar-chart-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none hidden lg:block">
            <div className="relative">
              <div className="absolute -inset-4 bg-accent-500/10 rounded-2xl blur-2xl"></div>
              <div className="relative grid grid-cols-2 gap-3">
                <div className="col-span-2">
                  <div className="bg-background-50/10 backdrop-blur-sm border border-white/10 rounded-xl p-4">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="px-2 py-0.5 text-xs font-medium bg-accent-500/30 text-accent-300 rounded-full whitespace-nowrap">🔥 热搜第一</span>
                      <span className="text-xs text-white/50">3小时前</span>
                    </div>
                    <div className="text-sm font-medium text-white leading-snug mb-2">年度最大爆料！某顶流艺人税务问题全面曝光</div>
                    <div className="flex items-center gap-3 text-xs text-white/40">
                      <span><i className="ri-eye-line mr-1"></i>128万</span>
                      <span><i className="ri-chat-3-line mr-1"></i>3562</span>
                    </div>
                  </div>
                </div>
                <div className="bg-background-50/10 backdrop-blur-sm border border-white/10 rounded-xl p-3">
                  <div className="flex items-center gap-1 mb-2">
                    <span className="px-2 py-0.5 text-xs font-medium bg-primary-500/30 text-primary-300 rounded-full whitespace-nowrap">爆</span>
                  </div>
                  <div className="text-xs font-medium text-white leading-snug">网红圈连环翻车！三大主播同日被曝</div>
                  <div className="text-xs text-white/40 mt-1">96万浏览</div>
                </div>
                <div className="bg-background-50/10 backdrop-blur-sm border border-white/10 rounded-xl p-3">
                  <div className="flex items-center gap-1 mb-2">
                    <span className="px-2 py-0.5 text-xs font-medium bg-accent-500/30 text-accent-300 rounded-full whitespace-nowrap">独家</span>
                  </div>
                  <div className="text-xs font-medium text-white leading-snug">电竞圈大地震！多支战队涉嫌违规</div>
                  <div className="text-xs text-white/40 mt-1">75万浏览</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}